var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:_vm.type,style:({'flex' : _vm.fullwidth ? '1 1 auto' : ''})},[_c('div',{class:_vm.isLoading ? 'loader' : '',domProps:{"textContent":_vm._s(_vm.isLoading ? '' : _vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }